import React from 'react';
import TopMenu from '@src/business-components/top-menu';
import MapStore from './store';
import useStore from '@src/utils/hooks/use-store';
import wrapStore from '@src/utils/wrap-store';
import styles from './index.less';
import Page from '@src/components/page';
import cx from 'classnames';
import Link from '@src/components/link';
import toWebpImage from '@src/utils/to-webp-image';
import CommonFooter from '@src/business-components/common-footer';

const Map = () => {
  const store = useStore(() => {
    return new MapStore();
  });

  return (
    <Page className={styles.root}>
      <TopMenu />
      <div className={styles.title} style={{
        backgroundImage: `url(${toWebpImage(require('./images/' + store.Lang() + '/title.png'))})`
      }} />
      <ul id="wallMain" className={cx(styles.wall_list, store.isWallShow ? styles.wall_list_act : '')}>
        {store?.wallpaperData?.map((item, index) => {
          return (
            <li key={index} className={cx(styles.wall_item)} >
              <img src={item.wallpaper_thumb} />
            </li>
          );
        })}
      </ul>
      {/* 底栏 */}
      <div className={styles.footerBox}>
        <CommonFooter />
      </div>
    </Page>
  );
};

export default wrapStore(Map, MapStore);
